import React from "react";
import ReactDOM from "react-dom";
import parse from "html-react-parser";
import './software.scss';

const Software = ({ activeSubmenu, hoveredSoftwareIndex, softwareTooltipPosition }) => {
  // const currentSubmenu = window.config?.allSubmenu?.find(
  //   (item) => item.id === activeSubmenu
  // );
  const currentSubmenu = window.config && window.config.allSubmenu ? window.config.allSubmenu.find((item) => item.id === activeSubmenu) : undefined;

  // const selectedProductType = window.selectedConfig?.ProductType?.toLowerCase();
  const selectedProductType = window.selectedConfig && window.selectedConfig.ProductType ? window.selectedConfig.ProductType.toLowerCase() : undefined;

  const softwareData = currentSubmenu.softwareContents.filter(sw => {
    if (!sw.configType || !sw.configType.ProductType) return true;
    return sw.configType.ProductType
      .map(p => p.toLowerCase())
      .includes(selectedProductType);
  });

  const container = document.getElementById("softwareContainer");
  if (!container) return null;

    // Mobile portrait / vertical list rendering
  if (window.isMobIsipadIsPotrait) {
    return (
      <div className="callout softwareCallout">
        <ul>
          {softwareData.map((sw, index) => (
            <li key={index} className="softwareItem">
              {parse(sw.text)}
              {sw.disclaimer && (
                <div className="mobSoftwareDisclaimer">
                  {parse(sw.disclaimer)}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    );

    // below code is where we have to align next to text
    // return (
    //   <div className="callout softwareCallout">
    //     <ul>
    //       {softwareData.map((sw, index) => (
    //         <li key={index} className="softwareItem">
    //           {parse(sw.text)}
    //           {sw.disclaimer && (
    //             <div className="SoftwareDisclaimer">
    //               {parse(sw.disclaimer)}
    //             </div>
    //           )}
    //         </li>
    //       ))}
    //     </ul>
    //   </div>
    // );
  }


  if (window.deviceBasedonBodyClass === "desktop" ||
    window.deviceBasedonBodyClass === "ipadDesktopLandscape" ||
    window.deviceBasedonBodyClass === "ipadLandscape" ||
    window.deviceBasedonBodyClass === "androidTabLandscape") {

    const maxColumns = 5;
    const totalItems = softwareData.length;
    const columns = Math.ceil(totalItems / Math.ceil(totalItems / maxColumns));

    return ReactDOM.createPortal(
      <div className="softwareWrapper" id={activeSubmenu} style={{ "--columns": columns }}>
        {softwareData.map((sw, index) => (
          <div key={index} className="softwareContent">
            {/* <div className="softwareImage">
              {sw.img && <img src={sw.img} alt={sw.text} />}
            </div> */}
            <div className="softwareText">
              {/* <p>{parse(sw.text)}</p> */}
              {sw.disclaimer && (
                <div id={`softwareItem_${index}`} className="softwareDisclaimer">
                  {parse(sw.disclaimer)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>,
      container
    );

    // below code is where we have to align next to text
    // return ReactDOM.createPortal(
    //   <div className="softwareWrapper" id={activeSubmenu} style={{ "--columns": columns }}>
    //     {softwareData.map((sw, index) => (
    //       <div key={index} className="softwareContent">
    //         {/* <div className="softwareImage">
    //           {sw.img && <img src={sw.img} alt={sw.text} />}
    //         </div> */}
    //         <div className="softwareText">
    //           {/* <p>{parse(sw.text)}</p> */}
    //           {/* {sw.disclaimer && ( */}
    //           {sw.disclaimer && index === hoveredSoftwareIndex && (
    //             // <div id={`softwareItem_${index}`} className="softwareDisclaimer">
    //             //   {parse(sw.disclaimer)}
    //             // </div>
    //             <div
    //               id={`softwareItem_${index}`}
    //               className="softwareDisclaimer"
    //               style={{
    //                 position: "fixed",
    //                 top: softwareTooltipPosition.top,
    //                 left: softwareTooltipPosition.left,
    //                 transform: "translateY(-50%)"
    //               }}
    //             >
    //               {parse(sw.disclaimer)}
    //             </div>
    //           )}
    //         </div>
    //       </div>
    //     ))}
    //   </div>,
    //   container
    // );
  }

};

export default Software;
